import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TareasComponent } from './tareas.component';

const routes: Routes = [
    {
        path: '',
        component: TareasComponent
    },
    {
        path: 'tarea-detalle/:id',
        loadChildren: 'app/pages/logueado/tareas/detalle-tarea-pagina/detalle-tarea-pagina.module#DetalleTareaPaginaModule'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TareasRoutingModule { }